module.exports = __webpack_public_path__ + "img/payment-cards.ee85f940.svg";